export type RoutePoint = [number, number];
const R = 6378137;
export function photoPlacement(imageWidth: number, imageHeight: number, width: number, height: number, zoom: number, x: number, y: number) {
  const scale = Math.max(width / imageWidth, height / imageHeight) * zoom / 100;
  const w = imageWidth * scale, h = imageHeight * scale;
  return { x: (width - w) * x / 100, y: (height - h) * y / 100, width: w, height: h, canPanX: w - width > .5, canPanY: h - height > .5 };
}
export function routeFrame(route: RoutePoint[], width: number, height: number) {
  const points = route.filter(([lat, lon]) => Number.isFinite(lat) && Number.isFinite(lon)).map(([lat, lon]) => [R * lon * Math.PI / 180, R * Math.log(Math.tan(Math.PI / 4 + Math.max(-85, Math.min(85, lat)) * Math.PI / 360))]);
  if (points.length < 2) return null;
  let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
  points.forEach(([x,y]) => { minX = Math.min(minX,x); maxX = Math.max(maxX,x); minY = Math.min(minY,y); maxY = Math.max(maxY,y); });
  const cx = (minX+maxX)/2, cy = (minY+maxY)/2;
  const units = Math.max((maxX-minX)*1.22/width, (maxY-minY)*1.22/height, 300/width);
  const left = cx-width*units/2, bottom = cy-height*units/2, right = cx+width*units/2, top = cy+height*units/2;
  return { points: points.map(([x,y]) => [(x-left)/units, (top-y)/units] as RoutePoint), bbox: [left,bottom,right,top] };
}
export const ESRI_CREDIT = 'Sources: Esri, HERE, Garmin, USGS, Intermap, INCREMENT P, NRCan, Esri Japan, METI, Esri China (Hong Kong), Esri Korea, Esri (Thailand), NGCC, © OpenStreetMap contributors, and the GIS User Community';
export function streetMapUrl(bbox: number[], width: number, height: number) {
  const params = new URLSearchParams({ bbox: bbox.join(','), bboxSR:'3857', imageSR:'3857', size:`${width},${height}`, format:'png32', transparent:'false', f:'image' });
  return `https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/export?${params}`;
}

/** White wordmark on dark photos; preserve the original green symbol and alpha. */
export function lightenShareLogo(pixels: Uint8ClampedArray): void {
  for(let i=0;i<pixels.length;i+=4) {
    if(!pixels[i+3]) continue;
    const green=pixels[i+1]>pixels[i]+20 && pixels[i+1]>pixels[i+2]+20;
    if(!green) pixels[i]=pixels[i+1]=pixels[i+2]=255;
  }
}
